<template>
  <van-popup class="ai-pop" v-model="showPopup" position="bottom">
    <div class="ai-review-popup">
      <div class="popup-header">
        <van-icon
          class="popup-close-btn"
          @click="showPopup = false"
          name="cross"
        />
        <img
          class="popup-header-img"
          src="https://cdnvue.gymcity.com.cn/uploads/ai-outline-top-bg-details"
          alt=""
        />
        <div class="header-center-text">
          <span class="text-normal">已累计守护</span
          ><span class="text-highlight">{{ formattedTotal }}</span
          ><span class="text-normal">次训练</span>
        </div>
      </div>
      <div class="popup-body">
        <div class="result-header">
          <div class="result-tag">
            <span> 根据你的专属评估数据，训练计划已通过AI审核</span>
          </div>

          <div class="result-title">符合训练目标，动作安全无风险</div>
        </div>
        <div class="popup-list">
          <div
            class="list-item"
            v-for="(item, index) in aiPassList"
            :key="index"
          >
            <div class="list-item-pass">
              <img
                src="https://cdnvue.gymcity.com.cn/uploads/ai-outline-details-gou"
                alt=""
                class="pass-index"
              />
              <span class="pass-label">{{ item.label }}</span>
              <span class="pass-tag">通过</span>
            </div>
          </div>
        </div>
      </div>
      <div class="popup-footer">
        <van-button class="popup-btn" type="info" @click="showPopup = false"
          >好的</van-button
        >
      </div>
    </div>
  </van-popup>
</template>

<script>
import { Popup, Button, Icon } from 'vant'
import { divide, round } from 'lodash'
export default {
  name: 'ai-review-popup',
  components: {
    [Popup.name]: Popup,
    [Button.name]: Button,
    [Icon.name]: Icon
  },
  props: {
    visible: {
      type: Boolean,
      default: false
    },
    plan: {
      type: Object,
      default: () => {}
    }
  },
  data() {
    return {
      aiPassList: [
        { label: '训练目标内容填写' },
        { label: '热身动作填写是否规范' },
        { label: '主体动作填写是否规范' },
        { label: '有氧训练是否规范' },
        { label: '热身动作完整性' },
        { label: '计划目标和主体动作匹配' },
        { label: '热身和主体动作部位匹配' },
        { label: '高风险动作检查' }
      ]
    }
  },
  computed: {
    showPopup: {
      get() {
        return this.visible
      },
      set(val) {
        this.$emit('update:visible', val)
      }
    },
    formattedTotal() {
      const wan = round(divide(this.plan.ai_total, 10000), 1)
      return wan + '万'
    }
  }
}
</script>

<style scoped lang="scss">
@function vw($px) {
  @return ($px / 375) * 100vw;
}
.ai-pop {
  border-radius: vw(16) vw(16) 0 0;
  overflow-y: visible;
  background: #fff;
  max-height: 95vh;
  padding-bottom: calc(constant(safe-area-inset-bottom));
  padding-bottom: calc(env(safe-area-inset-bottom));
  ::v-deep {
    .van-popup__close-icon {
      color: #303038;
      font-size: vw(17);
      top: vw(20);
    }
  }
}
.ai-review-popup {
  .popup-header {
    position: relative;
    display: flex;
    justify-content: center;
    .popup-close-btn {
      position: absolute;
      top: vw(16);
      right: vw(16);
      font-size: vw(18);
      color: #333333;
      z-index: 1;
    }
    .popup-header-img {
      width: 100%;
      display: block;
    }
    .header-center-text {
      position: absolute;
      top: vw(46);
      left: vw(131);
      height: vw(20);
      display: flex;
      align-items: center;
      background: #ffffff;
      border-radius: vw(4);
      padding-left: vw(18);
      padding-right: vw(15);
      font-size: vw(12);
      font-weight: 500;
      color: #000000;
      .text-highlight {
        color: #ff2b48;
      }
    }
  }
  .popup-body {
    padding: vw(16);
    border-radius: vw(16) vw(16) 0 0;
    background: #fff;
    margin-top: vw(-19);
    position: relative;
    max-height: 55vh;
    overflow-y: auto;
    .result-header {
      text-align: center;
      margin-bottom: vw(16);
      .result-tag {
        background: #eff6ff;
        color: #0e6aec;
        display: inline-block;
        font-size: vw(12);
        line-height: vw(17);
        padding: vw(3) vw(9) vw(3) vw(14);
        border-radius: vw(4);
        margin-bottom: vw(7);
      }
      .result-title {
        font-size: vw(18);
        line-height: vw(25);
        font-weight: 600;
        color: #0e6aec;
      }
    }
    .popup-list {
      border: 1px solid #f1f1f1;
      background: #f7f7f7;
      border-radius: vw(6);
      padding: vw(16);
      padding-right: vw(14);
      .list-item {
        margin-bottom: vw(12);
        &:last-child {
          margin-bottom: 0;
        }
      }
      .list-item-pass {
        display: flex;
        align-items: center;
        .pass-index {
          width: vw(14);
          margin-right: vw(8);
        }
        .pass-label {
          flex: 1;
          font-size: vw(14);
          line-height: vw(20);
          color: #000000;
        }
        .pass-tag {
          color: #0e6aec;
          font-size: vw(12);
          font-weight: 500;
        }
      }
    }
  }
  .popup-footer {
    padding: 0 vw(16);
    padding-bottom: vw(10);
    .popup-btn {
      width: 100%;
      height: vw(44);
      border-radius: vw(8);
      font-size: vw(15);
      font-weight: 500;
    }
  }
}
</style>
